import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { currentBudgetSelector } from "../currentBudgetSelector";

export const currentBudgetViewIdSelector = createDraftSafeSelector(
  [currentBudgetSelector],
  (budget) => budget?.["view-id"],
);
